"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeSorter = exports.stringSorter = exports.preferredOrderSorter = exports.multiStringSorter = exports.digitSorter = exports.boolSorter = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getSorterKeyOrPredicateValue = function getSorterKeyOrPredicateValue(value, keyOrPredicate, isDeepKey) {
  return (0, _lodash.isFunction)(keyOrPredicate) ? keyOrPredicate(value) : isDeepKey ? (0, _lodash.get)(value, keyOrPredicate) : value[keyOrPredicate];
};
var boolSorter = function boolSorter(key) {
  return function (a, b) {
    if (a[key] && !b[key]) {
      return -1;
    }
    if (!a[key] && b[key]) {
      return 1;
    }
    return 0;
  };
};
exports.boolSorter = boolSorter;
var stringSorter = function stringSorter(keyOrPredicate) {
  var isDeepKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (a, b) {
    var valueA = getSorterKeyOrPredicateValue(a, keyOrPredicate, isDeepKey);
    var valueB = getSorterKeyOrPredicateValue(b, keyOrPredicate, isDeepKey);
    return (0, _lodash.toString)(valueA).localeCompare((0, _lodash.toString)(valueB));
  };
};
exports.stringSorter = stringSorter;
var multiStringSorter = function multiStringSorter(keys) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
  return function (a, b) {
    var nameA = composeValueByKeys(a, keys, separator);
    var nameB = composeValueByKeys(b, keys, separator);
    return sorter(nameA, nameB);
  };
};
exports.multiStringSorter = multiStringSorter;
var timeSorter = function timeSorter(path) {
  return function (a, b) {
    var valueA = (0, _lodash.get)(a, path);
    var valueB = (0, _lodash.get)(b, path);
    var timeA = (0, _momentTimezone.default)(valueA);
    var timeB = (0, _momentTimezone.default)(valueB);
    var valueAExists = !!valueA && timeA.isValid();
    var valueBExists = !!valueB && timeB.isValid();
    if (!valueAExists && !valueBExists) {
      return 0;
    }
    if (!valueAExists) {
      return 1;
    }
    if (!valueBExists) {
      return -1;
    }
    return timeA - timeB;
  };
};
exports.timeSorter = timeSorter;
var preferredOrderSorter = function preferredOrderSorter(path, preferredOrder) {
  return function (a, b) {
    return preferredOrder.indexOf((0, _lodash.get)(a, path)) - preferredOrder.indexOf((0, _lodash.get)(b, path));
  };
};
exports.preferredOrderSorter = preferredOrderSorter;
var digitSorter = function digitSorter(keyOrPredicate) {
  var isDeepKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (a, b) {
    var valueA = getSorterKeyOrPredicateValue(a, keyOrPredicate, isDeepKey);
    var valueB = getSorterKeyOrPredicateValue(b, keyOrPredicate, isDeepKey);
    var aInt = parseInt(valueA);
    var bInt = parseInt(valueB);
    if (aInt < bInt) {
      return -1;
    } else if (aInt > bInt) {
      return 1;
    } else if (aInt === bInt) {
      return 0;
    }
  };
};
exports.digitSorter = digitSorter;
function composeValueByKeys(item) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ' ';
  return keys.map(function (key) {
    return item[key];
  }).filter(function (v) {
    return !!v;
  }).join(separator);
}
function sorter(a, b) {
  var nameA = (a || '').toUpperCase();
  var nameB = (b || '').toUpperCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
}